// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.siSLO1JZkuwIUlsSjJ_V{flex-direction:column;gap:24px;padding:40px 0 24px;display:flex}.JiSTYWeXcfwGF3Bct3Cv{padding:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `siSLO1JZkuwIUlsSjJ_V`,
	"grid": `JiSTYWeXcfwGF3Bct3Cv`
};
export default ___CSS_LOADER_EXPORT___;
